import { ISetTieuChuanSanPham } from "../../model/respone/set-tieu-chuan/ISetTieuChuanSanPham"
import { apiClient } from "../apiClient"

export const SET_TIEU_CHUAN_SAN_PHAM_RESOURCE = "set-tc-san-pham"
export const setTieuChuanSanPhamApi = {
    SelectAll: () => apiClient.get(`${SET_TIEU_CHUAN_SAN_PHAM_RESOURCE}`),
    Insert: (payload: ISetTieuChuanSanPham) => apiClient.post(`${SET_TIEU_CHUAN_SAN_PHAM_RESOURCE}`,payload),
    Update: (payload: ISetTieuChuanSanPham) => apiClient.put(`${SET_TIEU_CHUAN_SAN_PHAM_RESOURCE}`,payload),
    Delete: (id: number) => apiClient.delete(`${SET_TIEU_CHUAN_SAN_PHAM_RESOURCE}/${id}`),
    SelectDetailByStc: (id: number) => apiClient.get(`${SET_TIEU_CHUAN_SAN_PHAM_RESOURCE}/stc/${id}`),

}